export const ACTIVATE_CLEAR = 'ACTIVATE_CLEAR';
export const ACTIVATE_FINISH = 'ACTIVATE_FINISH';
